var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2849_501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0.46875C6.97266 0.46875 0.46875 6.97266 0.46875 15C0.46875 23.0273 6.97266 29.5312 15 29.5312C23.0273 29.5312 29.5312 23.0273 29.5312 15C29.5312 6.97266 23.0273 0.46875 15 0.46875ZM15 6.09375C17.8477 6.09375 20.1562 8.40234 20.1562 11.25C20.1562 14.0977 17.8477 16.4062 15 16.4062C12.1523 16.4062 9.84375 14.0977 9.84375 11.25C9.84375 8.40234 12.1523 6.09375 15 6.09375ZM15 26.25C11.5605 26.25 8.47852 24.6914 6.41602 22.2539C7.51758 20.1797 9.67383 18.75 12.1875 18.75C12.3281 18.75 12.4688 18.7734 12.6035 18.8145C13.3652 19.0605 14.1621 19.2188 15 19.2188C15.8379 19.2188 16.6406 19.0605 17.3965 18.8145C17.5312 18.7734 17.6719 18.75 17.8125 18.75C20.3262 18.75 22.4824 20.1797 23.584 22.2539C21.5215 24.6914 18.4395 26.25 15 26.25Z",
    fill: "#E7EF7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2849_501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.9d23fa18aea46f3cfae038eb813ae7a6.svg";
export { ForwardRef as ReactComponent };